
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import FormModal from "@/components/base/FormModal.vue";
import TrashBtn from "@/components/base/buttons/TrashBtn.vue";
import ImageInput from "@/components/base/form/ImageInput.vue";
import ImageNotesFile from "@/components/base/ImageNotesFile.vue";
import SvgClip from '@/assets/icons/clip.svg';
import SvgMagick from "@/assets/icons/magic-wand-light.svg";

@Component({
    components: { ImageNotesFile, ImageInput, TrashBtn, FormModal, SvgMagick, SvgClip },
})

export default class FormCreateNote extends Vue {
    @PropSync('isShowModal', { default: false }) isShowModalSync!: boolean;
    @PropSync('note', {}) noteSync!: string;
    @PropSync('image', {}) imageSync!: any;
    @Prop({ default: 'Новая заметка' }) formTitle!: string;
    @Prop({ default: 'Создать заметку' }) approveText!: string;
    @Prop({ default: true }) isAddFile!: boolean;

    addNote(): void {
        this.$emit('add-note');
    }
}
